export class Point {

    constructor(
        public x: number,
        public y: number,
    ) {
    }

}
